import { render } from "./DNumSlider.vue?vue&type=template&id=853a8a32&lang=pug"
import script from "./DNumSlider.vue?vue&type=script&lang=js"
export * from "./DNumSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__